<template>
  <span class="linkified" v-html="html"></span>
</template>

<script>
import { linkifyText } from '@/lib/linkify';

// Wraps a plain-text string so any URLs inside it render as clickable links.
// Use anywhere you'd otherwise write `{{ text }}` and want auto-link detection:
//   <LinkifiedText :text="row.note" />
//   <LinkifiedText :text="field.value" :newline-to-br="false" />
//
// The non-URL portion is HTML-escaped, so it's safe to feed user input.
export default {
  name: 'LinkifiedText',
  props: {
    text: { type: [String, Number], default: '' },
    newlineToBr: { type: Boolean, default: true },
  },
  computed: {
    html() {
      return linkifyText(this.text, { newlineToBr: this.newlineToBr });
    },
  },
};
</script>

<style>
/* Global so the rule reaches the v-html anchor (not scoped to this component). */
.auto-link {
  color: #2563eb;
  text-decoration: underline;
  word-break: break-all;
}
.auto-link:hover {
  color: #1d4ed8;
}
.auto-link:visited {
  color: #2563eb;
}
</style>
